import { Button, Modal } from "@ts-digital/vrc";
import React, { useState } from "react";
import NatureModalContent from "./modalContent";
import "./style.css";

const ModalNature = ({ onChange, onClose, visible, initialValue }) => {

  const [selected, setSelected] = useState(null);

  return (
    <Modal
      visible={visible}
      closable={true}
      backdrop={false}
      onClose={() => onClose()}
      footer={
        <div className="split-article-footer">
          <Button
            kind="primary"
            onClick={() => {
              if (selected) {
                onChange(selected.id, selected.nature);
              }
              onClose();
            }}
          >
              Salva
          </Button>
        </div>
      }
      title="Aliquota"
    >
      <NatureModalContent onChange={onChange} initialValue={initialValue} isModal={false} selected={selected} setSelected={setSelected} />
    </Modal>
  );
};

export default ModalNature;
